<template>
  <bg-style v-if="enabled" class="store-widget-v3" :is-disabled="$store.getters.isStandAloneMode" :class="{ 'is-mobile': $store.getters.isMobile }" :bg="model.background" :style="getStyle">
    <module-block :bg="model.background">
      <div class="title-box">
        <rich-text v-if="model.titleVisible" v-model="model.title" :disabled="!editing" :editing="editing"
          class="w-full" placement="bottom" theme="snow" />
        <div v-if="model.describeVisible" class="flex items-center justify-between mt-3 relative">
          <rich-text v-model="model.describe" :disabled="!editing" :editing="editing"
            class="describe w-full relative" />
          <div class="help-icon" @click="handleNavClick">
            <span>{{ $t('siteBuild.howToUse') }}</span>
            <i class="el-icon-question" />
          </div>
        </div>
      </div>
      <div class="store-widget-v3__list">
        <goods-item v-for="item in list" :key="item.id" :good="item" :model="model" :active="currentId === item.id"
          @click.native="handleItemClick(item)" />
      </div>
      <div v-if="list.length" class="store-widget-v3__handle relative">
        <div class="flex items-center justify-between number-box">
          <div>
            <div class="h1">{{ $t('siteBuild.buyNumber') }}</div>
            <div class="h4 !ml-0">{{ $t('siteBuild.buyTip') }}</div>
          </div>
          <el-input-number v-model="number" :min="1" size="small" />
        </div>
        <div class="flex items-center justify-between mt-5">
          <div class="goods-info font-bold">
            <div>
              <span>{{ $t('siteBuild.goodsInfo') }}: </span>
              <div>
                <span>{{ firstContentItem?.num + firstGiftsItem?.num }}{{ getLangIdI18n({ lang_id: firstContentItem?.name }, $store.state.locale.langIdData) }}</span>
                <span v-if="firstGiftsItem" class="extra">[{{ $t('siteBuild.extraGift') }} {{ firstGiftsItem.num}}]</span>
                <template v-if="currentGoods?.id">
                  <i class="el-icon-close" />
                  <span>{{ number }}</span>
                </template>
              </div>   
            </div>
            <div class="price-shadow">{{ $t('siteBuild.totalAmount') }}: <span v-if="currentGoods?.code" class="green">{{ totalPrice }}</span></div>
          </div>
          <div class="flex items-center font-bold">
            <div class="h2">{{ $t('siteBuild.totalAmount') }}: <span v-if="currentGoods?.code" class="green">{{ totalPrice }}</span></div>
            <div class="submit" @click="handleSubmit">{{ $t('siteBuild.shopCart.buy') }}</div>
          </div>
        </div>
      </div>
    </module-block>
    <desk-pay-modal v-if="deskPay.visible" :desk-pay="deskPay" :lang-id-data="$store.state.locale.langIdData" @close="closePay" />
  </bg-style>
</template>

<script>
import { Message, InputNumber } from 'element-ui'
import cloneDeep from 'lodash.clonedeep'
import GoodsItem from './item.vue'
import ModuleBlock from '~/components/common/ModuleBlock.vue'
import tools, {
  checkIgnoreMessage,
  checkUser,
  generateOrderParams,
  generatePayUrl,
  getLangIdI18n,
  getTextColor,
  navTo
} from '~/utils'
import richText from '~/components/richText/index.vue'
import DeskPayModal from '~/components/pay/deskPayModal.vue'
import Bus from '~/site/model/bus'

export default {
  components: {
    DeskPayModal,
    richText,
    ModuleBlock,
    GoodsItem,
    [InputNumber.name]: InputNumber
  },
  props: {
    model: Object,
    editing: Boolean,
    goods: Object,
    site: Object
  },
  data() {
    return {
      enabled: false,
      currentIndex: 0,
      list: [],
      number: 1,
      currentId: null,
      loading: false,
      deskPay: {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
    }
  },
  computed: {
    getStyle() {
      return {
        '--store-v3-bg': getTextColor(this.model.background).color,
        '--text-color': getTextColor(this.model.textColor).color,
        '--price-color': getTextColor(this.model.priceColor).color,
        '--button-bg': getTextColor(this.model.buttonBackground).color,
        '--button-color': getTextColor(this.model.buttonColor).color
      }
    },
    currentGoods() {
      return this.list.find(item => item.id === this.currentId)
    },
    firstContentItem() {
      return this.currentGoods?.item_contents?.[0]
    },
    firstGiftsItem() {
      return this.currentGoods?.gift_list?.[0]
    },
    totalPrice() {
      const priceInfo = this.currentGoods?.priceInfo || {}
      const price = (priceInfo?.price * this.number).toFixed(2)
      return `${priceInfo.currencyLabel} ${price}`
    },
    awaitGoods() {
      return this.$store.state.site.awaitGoods
    }
  },
  watch: {
    'model.classId'(n, o) {
      if (n !== o) {
        this.getGoodsById()
      }
    }
  },
  beforeDestroy() {
    Bus.$off('reloadGood')
  },
  mounted() {
    this.init()
    Bus.$on('reloadGood', (type) => {
      const isLogin = type === 'login'
      if (isLogin) {
        this.checkBuy()
      }
    })
  },
  methods: {
    checkEnabled() {
      if (this.editing) {
        this.enabled = true
      } else if (this.list?.length) {
        this.enabled = true
      }
    },
    getLangIdI18n,
    checkBuy() {
      const isAim = this.awaitGoods && (this.awaitGoods.modelId === this.model.id)
      if (isAim) this.createOrder(this.awaitGoods.data)
    },
    closePay() {
      this.deskPay = {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
    },
    async init() {
      await this.$store.dispatch('goods/getGroupList', this)
      await this.getGoodsById()
    },
    async getGoodsById() {
      if (!this.model.classId && this.editing) {
        this.list = this.model.__mockData
        this.checkEnabled()
        return
      } else if (!this.model.classId) {
        this.checkEnabled()
        return
      }
      const params = {
        pageSize: 200,
        pageNo: 1,
        group_id: this.model.classId,
        project_id: this.$store.state.project.projectId
      }
      const [err, res] = await this.$utils.to(this.$api.good.getAllGoodsList(params, this.editing))
      if (!err) {
        this.list = (res.data?.[0]?.data || []).map(item => {
          const newItem = { ...item }
          newItem.priceInfo = tools.getPriceInfo(newItem.prices_setting, tools.getLangByip(this), this)
          return newItem
        })
        this.currentId = this.list[0]?.id || null
        this.checkEnabled()
      } else {
        Message.error(err)
      }
    },
    async createOrder(goods) {
      this.loading = true
      const [err, res] = await this.$utils.to(generateOrderParams(this, goods || { ...this.currentGoods, num: this.number }))
      this.loading = false
      if (!err) {
        this.$store.commit('site/SET_AWAIT_GOODS', null)
        generatePayUrl(res, this)
      } else {
        !checkIgnoreMessage(err) && Message.error(err)
      }
    },
    async handleSubmit() {
      if (this.editing || this.loading) return
      await checkUser(this, () => {
        this.$store.commit('site/SET_AWAIT_GOODS', { modelId: this.model.id, data: cloneDeep(this.currentGoods) })
      })
      await this.createOrder()
    },
    handleNavClick() {
      if (this.editing) return
      navTo(this, this.model.nav)
    },
    handleItemClick(item) {
      this.currentId = item.id
    }
  }
}
</script>

<style lang="less">
.store-widget-v3 {
  padding: 20px 0;

  .title-box {
    max-width: 788px;
    margin: 0 auto;

    .help-icon {
      flex-shrink: 0;
      background-color: var(--button-bg);
      padding: 5px 10px;
      border-radius: 4px;
      margin-left: 20px;
      color: var(--button-color);
      cursor: pointer;
    }
  }

  &__list {
    display: grid;
    max-width: 788px;
    margin: 20px auto 0 auto;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0 12px;
  }

  &__handle {
    max-width: 788px;
    margin: 0 auto;
    padding-top: 40px;
    color: var(--text-color);

    .el-input-number {
      flex-shrink: 0;
    }

    .number-box {
      padding-bottom: 20px;
      border-bottom: 2px solid var(--price-color);
    }

    .info-box {
      display: flex;
      align-items: baseline;
    }

    .goods-info {
      .price-shadow {
        display: none;
      }
    }

    .el-input__inner {
      background-color: var(--button-bg);
      color: var(--button-color);
      border: none;
      font-size: 18px;
      font-weight: bold;
    }

    .el-input-number__increase,
    .el-input-number__decrease {
      background-color: var(--button-bg);
      color: var(--button-color);
      font-weight: bold;
      border: none;

      &:hover {
        color: var(--button-color);
      }

      i {
        font-size: 20px;
        font-weight: bold;
      }
    }

    .h1 {
      font-size: 24px;
      font-weight: bold;
    }

    .h2 {
      font-size: 16px;
    }

    .h4 {
      margin-left: 20px;
    }

    .submit {
      line-height: 32px;
      background-color: var(--button-bg);
      color: var(--button-color);
      border-radius: 4px;
      min-width: 130px;
      margin-left: 20px;
      cursor: pointer;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }

    .extra {
      color: #FDA368;
    }
    .green {
      color: greenyellow;
    }
  }

  &.is-mobile {
    padding: 10px;

    .store-widget-v3__list {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 0;
    }

    .store-widget-v3__handle {
      padding: 20px 5px 0 5px;

      .h2 {
        display: none;
      }
      .h1 {
          font-size: 16px;
        }
      .info-box {
        flex-direction: column;
        .h4 {
          margin-left: 0;
          font-size: 12px;
        }
      }

      .goods-info {
        font-size: 12px;

        .price-shadow {
          display: block;
        }
      }

      .el-input-number {
        width: 110px;
      }

      .el-input__inner {
        font-size: 14px;
      }

      .el-input-number__increase,
      .el-input-number__decrease {
        i {
          font-size: 14px;
        }
      }

      .submit {
        min-width: 110px;
        font-size: 14px;
        margin-left: 0;
      }
    }
  }
}
</style>
